import React, {useEffect, useRef, useState} from 'react';
import QRCode from 'qrcode';

export function QRCodeSheet({ isVisible, onClose, qrData, title = "QR-код ключа" }) {
    const canvasRef = useRef(null);
    const sheetRef = useRef(null);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);
    const [isDragging, setIsDragging] = useState(false);

    // Генерируем QR-код при открытии
    useEffect(() => {
        if (isVisible && canvasRef.current && qrData) {
            QRCode.toCanvas(canvasRef.current, qrData, {
                width: 200,
                margin: 2,
                color: {
                    dark: '#000000',
                    light: '#ffffff'
                }
            }, (error) => {
                if (error) console.error('Ошибка генерации QR-кода:', error);
            });
        }
    }, [isVisible, qrData]);

    // Блокируем прокрутку при открытии
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    const handleClose = () => {
        onClose();
    };

    // Touch events для мобильных
    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
        setIsDragging(true);
    };

    const handleTouchMove = (e) => {
        if (startY === null || !isDragging) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);

            if (sheetRef.current) {
                const maxTranslate = window.innerHeight * 0.6;
                const translateY = Math.min(diff, maxTranslate);
                sheetRef.current.style.transform = `translateY(${translateY}px)`;
                sheetRef.current.style.transition = 'none';
            }
        }
    };

    const handleTouchEnd = () => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            handleClose();
        }

        if (sheetRef.current) {
            sheetRef.current.style.transform = '';
            sheetRef.current.style.transition = 'transform 0.3s ease-out';
        }

        setStartY(null);
        setCurrentY(null);
        setIsDragging(false);
    };

    // Mouse events для десктопа
    const handleMouseDown = (e) => {
        e.preventDefault();
        setStartY(e.clientY);
        setIsDragging(true);

        const handleMouseMove = (e) => {
            if (startY === null || !isDragging) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);

                if (sheetRef.current) {
                    const maxTranslate = window.innerHeight * 0.6;
                    const translateY = Math.min(diff, maxTranslate);
                    sheetRef.current.style.transform = `translateY(${translateY}px)`;
                    sheetRef.current.style.transition = 'none';
                }
            }
        };

        const handleMouseUp = (e) => {
            const diff = currentY || 0;

            if (diff > 100) {
                handleClose();
            }

            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
                sheetRef.current.style.transition = 'transform 0.3s ease-out';
            }

            setStartY(null);
            setCurrentY(null);
            setIsDragging(false);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    return (
        <div className={`confirmation-sheet-wrapper ${isVisible ? 'visible' : ''}`}>
            <div
                className="sheet-overlay"
                onClick={handleClose}
            />

            <div
                ref={sheetRef}
                className="confirmation-sheet qr-sheet"
                style={{ transition: 'transform 0.3s ease-out'}}
            >
                <div className="sheet-content">
                    {/* Ползунок для закрытия */}
                    <div
                        className="sheet-drag-handle"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div className="drag-indicator" />
                    </div>

                    {/* Заголовок */}
                    <h3 className="sheet-title">
                        {title}
                    </h3>

                    {/* Контейнер с QR-кодом */}
                    <div className="qr-code-container">
                        <canvas
                            ref={canvasRef}
                            className="qr-code-canvas"
                        />
                    </div>

                    {/* Текст под QR-кодом */}
                    <div className="custom-content-box qr-content">
                        <p className="custom-content-text">
                            Наведите камеру на QR-код<br />
                            для быстрого подключения
                        </p>
                    </div>

                    {/* Кнопка закрытия */}
                    <div className="sheet-buttons">
                        <button
                            className="sheet-button btn-green"
                            onClick={handleClose}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}